export const queryDevices = () => ({
    method: 'get',
    url: 'drive/devices',
});
